(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-search"] && !Shopify.designMode) return;
  try {
    (function () {
  function initSearchPlaceholder(input) {
    if (input.dataset.placeholderInit) return;
    input.dataset.placeholderInit = 'true';

    const raw = input.dataset.searchSuggestions;
    if (!raw) return;

    const suggestions = raw.split('|').filter(Boolean);
    if (suggestions.length === 0) return;

    const label = document.querySelector('label[for="' + input.id + '"]');

    let index = 0;
    let charIndex = 0;
    let typeTimer = null;
    let holdTimer = null;

    function applyText(text) {
      input.setAttribute('placeholder', text);
      if (label) {
        label.textContent = text;
      }
    }

    function typeNext() {
      const fullText = 'Search "' + suggestions[index] + '"';
      charIndex++;
      applyText(fullText.slice(0, charIndex));

      if (charIndex < fullText.length) {
        typeTimer = setTimeout(typeNext, 60);
      } else {
        holdTimer = setTimeout(function () {
          index = (index + 1) % suggestions.length;
          charIndex = 0;
          typeNext();
        }, 1800);
      }
    }

    function startTyping() {
      clearTimeout(typeTimer);
      clearTimeout(holdTimer);
      charIndex = 0;
      typeNext();
    }

    startTyping();
  }

  function setup() {
    document.querySelectorAll('.search__input[data-search-suggestions]').forEach(initSearchPlaceholder);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pincode-checker"] && !Shopify.designMode) return;
  try {
    (function () {
  let pincodeData = null;
  let isFetching = false;

  async function loadPincodeData(jsonUrl) {
    if (pincodeData || isFetching) return pincodeData;
    isFetching = true;
    try {
      const response = await fetch(jsonUrl);
      if (!response.ok) {
        console.error('Pincode file fetch failed with status:', response.status);
      }
      pincodeData = await response.json();
    } catch (err) {
      console.error('Pincode data load failed:', err);
      pincodeData = {};
    }
    isFetching = false;
    return pincodeData;
  }

  function initPincodeChecker(root) {
    if (root.dataset.pincodeInit) return;
    root.dataset.pincodeInit = 'true';

    const jsonUrl = root.dataset.pincodeJsonUrl;
    const input = root.querySelector('.pincode-checker__input');
    const button = root.querySelector('.pincode-checker__button');
    const result = root.querySelector('.pincode-checker__result');

    if (!input || !button || !result) return;

    input.addEventListener('input', function () {
      input.value = input.value.replace(/[^0-9]/g, '');
    });

    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        button.click();
      }
    });

    button.addEventListener('click', async function () {
      const pincode = input.value.trim();

      result.classList.remove('is-visible', 'is-success', 'is-error', 'is-invalid');

      if (pincode.length !== 6) {
        result.textContent = 'Please enter a valid 6-digit pincode.';
        result.classList.add('is-visible', 'is-invalid');
        return;
      }

      button.disabled = true;
      button.textContent = 'Checking...';

      const data = await loadPincodeData(jsonUrl);

      button.disabled = false;
      button.textContent = 'Check Pincode';

      const status = data[pincode];

      if (status === 'Y') {
        result.textContent = 'Delivery available at this pincode.';
        result.classList.add('is-visible', 'is-success');
      } else if (status === 'N') {
        result.textContent = 'Sorry, delivery is not available at this pincode.';
        result.classList.add('is-visible', 'is-error');
      } else {
        result.textContent = 'Sorry, we do not deliver to this pincode yet.';
        result.classList.add('is-visible', 'is-error');
      }
    });
  }

  function setup() {
    document.querySelectorAll('.pincode-checker').forEach(initPincodeChecker);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-variant-picker"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (e) {
  const openTrigger = e.target.closest('[data-size-chart-open]');
  if (openTrigger) {
    const modalId = openTrigger.getAttribute('data-size-chart-open');
    const modal = document.querySelector(`[data-size-chart-modal="${modalId}"]`);
    if (modal) {
      modal.setAttribute('data-open', 'true');
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }
  }

  if (e.target.closest('[data-size-chart-close]')) {
    document.querySelectorAll('[data-size-chart-modal][data-open="true"]').forEach(function (modal) {
      modal.setAttribute('data-open', 'false');
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    });
  }
});

document.addEventListener('keydown', function (e) {
  if (e.key === 'Escape') {
    document.querySelectorAll('[data-size-chart-modal][data-open="true"]').forEach(function (modal) {
      modal.setAttribute('data-open', 'false');
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    });
  }
});

document.addEventListener('click', function (e) {
  const tab = e.target.closest('[data-size-chart-tab]');
  if (tab) {
    const index = tab.getAttribute('data-size-chart-tab');
    const modal = tab.closest('.size-chart-modal');

    modal.querySelectorAll('[data-size-chart-tab]').forEach(t => t.classList.remove('is-active'));
    tab.classList.add('is-active');

    modal.querySelectorAll('[data-size-chart-image]').forEach(img => img.classList.remove('is-active'));
    modal.querySelector(`[data-size-chart-image="${index}"]`).classList.add('is-active');
  }
});
  } catch(e) { console.error(e); }
})();

})();
